<adapt-menu *ngIf="meetingMenu?.length"
            [items]="meetingMenu"
            data-tour="meeting-actions-button"
            data-test="meeting-actions-button"></adapt-menu>
